import { Badge as MuiBadge } from '@mui/material';
import type { BadgeProps as MuiBadgeProps } from '@mui/material';

export type BadgeProps = MuiBadgeProps;

/** Shows badge around the children component. Based on MUI Badge: https://mui.com/material-ui/react-badge/ */
export const Badge = (props: BadgeProps) => <MuiBadge {...props} />;
